document.addEventListener('DOMContentLoaded', () => {
  const popupButton = document.querySelectorAll<HTMLAnchorElement>('[data-tnc-popup-trigger]');
  const popup = document.querySelector<HTMLDivElement>('.terms-and-conditions__popup-overlay');

  if (!popup) {
    return;
  }

  popupButton.forEach((el) => {
    el.addEventListener('click', () => {
      if (!popup) {
        return;
      }

      popup.classList.add('active');
      document.querySelector('html')!.classList.add('tnc-popup-active');
    });
  });

  const popupCloseButton = document.querySelector('.terms-and-conditions__close-popup');

  if (!popupCloseButton) {
    return;
  }

  popupCloseButton.addEventListener('click', () => {
    popup.classList.remove('active');
    document.querySelector('html')!.classList.remove('tnc-popup-active');
  });

  popup.addEventListener('click', () => {
    popup.classList.remove('active');
    document.querySelector('html')!.classList.remove('tnc-popup-active');
  });
});
